import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import type { Report, AsyncUpdate } from 'types'

import { BannerRequestBody } from './types'

export const getCampaignFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post('/api/campaign_facts/aggregate/banner/', params, {
        headers: getCerebroHeaders(options.headers),
    })

export const asyncUpdateCampaignFacts = (
    data: any,
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroResourceResponse<AsyncUpdate>> =>
    orgScopedApiClient.patch(
        '/api/campaign_facts/aggregate/banner/mutate/',
        data,
        {
            params: { ...params, metrics: null },
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getCampaignFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        `/api/campaign_facts/aggregate/banner/export/`,
        params
    )
